import _ from 'lodash';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import { ImportExportTypeOptionsEnum } from 'Common/Constants/Enumeration/ImportExportInventoryEnum';

export const validateColumnData = (
  columnValue,
  columnNumber,
  columnMapping = [],
  columnsOptions = []
) => {
  let success = false,
    newColumnMapping = columnMapping.filter(
      c => c.ColumnNumber !== columnNumber && c.FieldName !== columnValue
    );

  // Get the column option from fixture list
  const option = _.find(columnsOptions, optObj => optObj.value === columnValue);

  // Get the current column from the columnMapping list
  const column = _.find(
    columnMapping,
    column => column.FieldName === option.value
  );

  // The user selected the same field on the same column. Silly.
  if (column && column.ColumnNumber === columnNumber) {
    success = true;
  } else if (!column) {
    // No column from the current list is found, it's a new column!
    success = true;

    newColumnMapping.push({
      FieldName: option.value,
      ColumnNumber: columnNumber,
    });
  }

  // If the user skips the column, remove the column from the mapping.
  if (columnValue === -1) {
    success = true;

    newColumnMapping = newColumnMapping.filter(c => {
      return c.ColumnNumber !== columnNumber;
    });
  }

  return [success, success ? newColumnMapping : columnMapping, option];
};
export const reorder = (list, startIndex, endIndex) => {
  const result = _.cloneDeep(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const getColumnOptions = (columns, isImportBidPrice) => {
  const defaultList = [
    {
      value: -1,
      key: 'skip',
      text: 'Skip',
    },
  ];
  return columns && !columns.length
    ? defaultList
    : [
        ...defaultList,
        ..._.map(
          _.filter(columns, columnDefinition =>
            isImportBidPrice
              ? columnDefinition[ImportExportItemsEnum.ImportAllowed]
              : columnDefinition[ImportExportItemsEnum.ImportAllowed] &&
                columnDefinition[ImportExportItemsEnum.ShowBidRelatedCol]
          ),
          items => {
            return {
              value: items.ColName,
              key: items.ColName,
              text: items.ColLabel,
            };
          }
        ),
      ];
};

export const validateExportForm = values => {
  const errors = {};

  if (!values[ImportExportItemsEnum.Delimiter]) {
    errors[ImportExportItemsEnum.Delimiter] =
      'Field Separator is required! Please enter Field Separator.';
  }

  return errors;
};

export const move = (
  sourceList,
  destinationList,
  droppableSource,
  droppableDestination
) => {
  const sourceClone = _.cloneDeep(sourceList);
  const destClone = _.cloneDeep(destinationList);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

export const importExportTypeOptions = [
  { label: 'One time only', value: ImportExportTypeOptionsEnum.OneTimeOnly },
  { label: 'Create new', value: ImportExportTypeOptionsEnum.New },
  {
    label: 'Load previously saved',
    value: ImportExportTypeOptionsEnum.LoadPreviouslySaved,
  },
];
export const yesNoOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const validateMandatoryColumn = (columnMapping, importBidPrice) => {
  let manColNames = [
    {
      ColName: ImportExportItemsEnum.ItemCode,
      ColLabel: 'Item Code',
    },
    {
      ColName: ImportExportItemsEnum.Description,
      ColLabel: 'Description',
    },
    {
      ColName: ImportExportItemsEnum.GroupId_Cat,
      ColLabel: 'Account Category',
    },
    {
      ColName: ImportExportItemsEnum.PrimaryPrice,
      ColLabel: 'Bid Price',
    },
    {
      ColName: ImportExportItemsEnum.Unit,
      ColLabel: 'Purchase Unit',
    },
    {
      ColName: ImportExportItemsEnum.QtyPerUnit,
      ColLabel: 'Pack Size',
    },
    {
      ColName: ImportExportItemsEnum.SecondaryUnit,
      ColLabel: 'Pack Unit',
    },
    {
      ColName: ImportExportItemsEnum.VendorNum,
      ColLabel: 'Distributor Number',
    },
    {
      ColName: ImportExportItemsEnum.VendorDescription,
      ColLabel: 'Distributor Description',
    },
  ];
  if (!importBidPrice) {
    manColNames = [
      {
        ColName: ImportExportItemsEnum.ItemCode,
        ColLabel: 'Item Code',
      },
    ];
  }
  _.forEach(columnMapping, colMap => {
    _.remove(manColNames, colName => {
      return (
        colName[ImportExportItemsEnum.ColName] ===
        colMap[ImportExportItemsEnum.FieldName]
      );
    });
  });
  return manColNames;
};

export const getExportColumnOptions = (columns) => {
  return columns && !columns.length
    ? []
    : _.filter(columns, columnDefinition => columnDefinition[ImportExportItemsEnum.ExportAllowed])
};

export const getColumnMappingOptions = (columnMapping, columns) =>{
  const columnMappingClone = _.clone(columnMapping);
  _.remove(columnMappingClone, column => {
    const res =
        _.findIndex(columns, col => {
          return column.FieldName === col.value;
        }) === -1;
    return res;
  });
  return columnMappingClone;
}


// WEBPACK FOOTER //
// ./src/pages/utilities/helper/importExport.js